import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTransactionSelection } from '../../context/transactionSelectionContext'
import { RfhColors } from '../../config/florimixColors'

type TransactionSelectAllBarProps = {
  transactionIds: string[]
}

export const TransactionSelectAllBar = ({
  transactionIds,
}: TransactionSelectAllBarProps) => {
  const { t } = useTranslation()
  const { selectedCount, selectedTransactionIds, selectAll, deselectAll } =
    useTransactionSelection()
  const allSelected =
    transactionIds.length > 0 &&
    transactionIds.every(id => selectedTransactionIds.includes(id))

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pl: 7,
        pr: 2,
        py: 1,
        backgroundColor: RfhColors.lightGrey,
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={allSelected}
            indeterminate={selectedCount > 0 && !allSelected}
            disabled={transactionIds.length === 0}
            onChange={() =>
              allSelected ? deselectAll() : selectAll(transactionIds)
            }
            sx={{
              position: 'absolute',
              left: theme => theme.spacing(0.5),
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          />
        }
        sx={{ margin: 0 }}
        label={t('transactions.selection.selectAll')}
      />
      <Button
        variant='text'
        disabled={selectedCount === 0}
        onClick={deselectAll}
        sx={{ color: RfhColors.dutchOrange }}
      >
        {t('transactions.selection.remove')}
      </Button>
    </Box>
  )
}
